import { COLLATERAL_URL, FETCH_GET_DEFAULT } from '@constants'
import { useQuery } from '@tanstack/react-query'
import { Collaterals } from 'src/types'
import { MINUTE } from '../constants/variables'

const getCollaterals = async () => {
  try {
    const response = await fetch(COLLATERAL_URL, FETCH_GET_DEFAULT)
    return response.json()
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
}

const useCollaterals = () => {
  const { data } = useQuery(['collaterals'], getCollaterals, { refetchInterval: MINUTE })

  return (data?.data || []) as Collaterals
}

export default useCollaterals
